export enum PackagesMultiStepType {

    SelectPackage = "selectPackage",
    ChooseAddons = "chooseAddons",
    Checkout = "checkout"
}
